import {MeshCellFontName} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/cellSettings/MeshCellFont';
import {
    DefaultMeshCellSettings,
    MeshCellColor
} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshCellSettings';
import {observable} from 'mobx';

// export interface ISetCellSettingsBarState
// {
//     isPaintFormatMode:boolean;
//     paintFormatData:any;
//     isBarVisible:boolean;
//     borderColor:MeshCellColor;
//     isBorderTypeDouble:boolean;
//     selectedBorderAction:CellSettingsBarBorderAction;
//     isMenuOpened:CellSettingsBarMenu;
//     tmpValue:MeshCellFontName | number | MeshCellColor;
// }

export type CellSettingsBarTmpValue = MeshCellFontName | number | MeshCellColor;

// export class CellSettingsBarState implements ISetCellSettingsBarState
export class CellSettingsBarState
{
    @observable
    isPaintFormatMode:boolean = false;

    paintFormatData:any = null;

    @observable
    isBarVisible:boolean = true;

    @observable
    borderColor:MeshCellColor = DefaultMeshCellSettings.borderColor;

    @observable
    isBorderTypeDouble:boolean = false;

    @observable
    selectedBorderAction:CellSettingsBarBorderAction;

    @observable
    isMenuOpened:CellSettingsBarMenu = null;

    @observable
    tmpValue:CellSettingsBarTmpValue = null;
}

export enum CellSettingsBarBorderAction
{
    All = 'All',
    Inside = 'Inside',
    Horizontal = 'Horizontal',
    Vertical = 'Vertical',
    Outside = 'Outside',

    Left = 'Left',
    Top = 'Top',
    Right = 'Right',
    Bottom = 'Bottom',
    None = 'None',
}

export enum CellSettingsBarMenu
{
    FontName = 'FontName',
    FontSize = 'FontSize',
    TextColor = 'TextColor',
    BgColor = 'BgColor',
    Border = 'Border',
    More = 'More',
}
